import React from "react";

import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { useKeycloak } from "@/auth/KeycloakAuthState.ts";
import { Button } from "@/uiKit/atoms/Button.tsx";
import { Typography } from "@/uiKit/atoms/Typography.tsx";

export const AdminPage: React.FC = () => {
  const keycloak = useKeycloak(state => state.keycloak);
  const { t } = useTranslation();

  return (
    <div
      className={css`
        display: flex;
        flex-direction: column;
      `}
      id="admin-page"
    >
      <Typography id="admin-title" variant="h4">
        {t("admin.title")}
      </Typography>
      <Button
        id="admin-logout"
        data-action="auth.session.logout"
        variant="contained"
        onClick={() =>
          keycloak.logout({
            redirectUri: window.origin,
          })
        }
      >
        {t("admin.logout")}
      </Button>
    </div>
  );
};
